import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/p/")({
  loader: () => {
    throw redirect({ to: "/account" });
  },
});
